// ── Shared emblems for the four Survival Games ──

export const CrownSVG = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <defs>
      <linearGradient id="crown-g" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#FFF9C4" />
        <stop offset="40%" stopColor="#FBBF24" />
        <stop offset="100%" stopColor="#92400E" />
      </linearGradient>
    </defs>
    <path d="M6 38 L42 38 L42 42 L6 42 Z" fill="url(#crown-g)" />
    <path d="M6 38 L10 18 L20 30 L24 10 L28 30 L38 18 L42 38 Z" fill="url(#crown-g)" stroke="#92400E" strokeWidth="1" strokeLinejoin="round" />
    <circle cx="24" cy="11" r="3.5" fill="#EF4444" />
    <circle cx="10" cy="19" r="2.5" fill="#EF4444" />
    <circle cx="38" cy="19" r="2.5" fill="#EF4444" />
    <path d="M8 36 L40 36" stroke="rgba(255,255,255,0.4)" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export const ShieldSVG = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <defs>
      <linearGradient id="shield-g" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#60A5FA" />
        <stop offset="100%" stopColor="#1D4ED8" />
      </linearGradient>
    </defs>
    <path d="M24 4 L40 10 L40 26 Q40 38 24 44 Q8 38 8 26 L8 10 Z" fill="url(#shield-g)" stroke="#93C5FD" strokeWidth="1.5" />
    <path d="M24 4 L40 10 L40 26 Q40 38 24 44 Q8 38 8 26 L8 10 Z" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="3" strokeDasharray="2 4" />
    <path d="M18 24 L22 28 L30 20" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const BrokenHeartSVG = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <defs>
      <linearGradient id="bheart-g" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#f472b6" />
        <stop offset="100%" stopColor="#be185d" />
      </linearGradient>
    </defs>
    <path d="M24 42 L6 22 C2 17 2 10 8 7 C13 4 18 6 21 10 L24 14 L27 10 C30 6 35 4 40 7 C46 10 46 17 42 22 Z"
      fill="url(#bheart-g)" stroke="#f9a8d4" strokeWidth="1.5" />
    <path d="M22 16 L19 25 L24 21 L21 32" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" opacity="0.95" />
  </svg>
);

export const StarSVG = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <defs>
      <linearGradient id="star-g" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#F472B6" />
        <stop offset="100%" stopColor="#9333EA" />
      </linearGradient>
    </defs>
    <path d="M24 4 L28.5 17 L42 17 L31.5 25.5 L35.5 39 L24 31 L12.5 39 L16.5 25.5 L6 17 L19.5 17 Z" fill="url(#star-g)" stroke="#F9A8D4" strokeWidth="1" />
    <path d="M24 4 L28.5 17 L42 17 L31.5 25.5 L35.5 39 L24 31 L12.5 39 L16.5 25.5 L6 17 L19.5 17 Z" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="2" />
  </svg>
);

export const DiamondSVG = ({ size = 48 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
    <defs>
      <linearGradient id="diamond-g" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#34D399" />
        <stop offset="100%" stopColor="#059669" />
      </linearGradient>
    </defs>
    <path d="M24 4 L44 18 L24 44 L4 18 Z" fill="url(#diamond-g)" stroke="#6EE7B7" strokeWidth="1.5" />
    <path d="M4 18 L44 18" stroke="rgba(255,255,255,0.3)" strokeWidth="1" />
    <path d="M14 10 L24 18 L34 10" stroke="rgba(255,255,255,0.3)" strokeWidth="1" />
    <path d="M24 18 L24 44" stroke="rgba(255,255,255,0.15)" strokeWidth="1" />
  </svg>
);
